export const getProviderClass = (hostname) => {
  const providerMap = {
    'netflix.com': 'provider--netflix',
    'netflix': 'provider--netflix',

    'amazon.com': 'provider--amazon',
    'amazon': 'provider--amazon',
    'primevideo.com': 'provider--amazon',

    'hbo.com': 'provider--hbo',
    'max': 'provider--hbo',
    'hbomax.com': 'provider--hbo',

    'disneyplus.com': 'provider--disney',
    'disney.com': 'provider--disney',
    'disney': 'provider--disney',

    'hulu.com': 'provider--hulu',
    'hulu': 'provider--hulu',

    'apple.com': 'provider--apple',
    'apple': 'provider--apple',

    'paramountplus.com': 'provider--paramount',
    'paramount.com': 'provider--paramount',
    'paramount': 'provider--paramount',

    'youtube.com': 'provider--youtube',
    'google.com': 'provider--youtube',
    'peacocktv.com': 'provider--peacock',
    'peacock.com': 'provider--peacock'
  };

  for (const [key, value] of Object.entries(providerMap)) {
    if (hostname.includes(key)) {
      return value;
    }
  }

  return '';
};

export const getProviderDisplayName = (hostname) => {
  const nameMap = {
    'netflix.com': 'Netflix',
    'netflix': 'Netflix',

    'amazon.com': 'Prime Video',
    'primevideo.com': 'Prime Video',
    'amazon': 'Prime Video',

    'hbo.com': 'HBO Max',
    'hbomax.com': 'HBO Max',
    'max': 'HBO Max',

    'disneyplus.com': 'Disney+',
    'disney.com': 'Disney+',
    'disney': 'Disney+',

    'hulu.com': 'Hulu',
    'hulu': 'Hulu',

    'apple.com': 'Apple TV+',
    'apple': 'Apple TV+',

    'paramountplus.com': 'Paramount+',
    'paramount.com': 'Paramount+',
    'paramount': 'Paramount+',

    'youtube.com': 'YouTube',
    'google.com': 'YouTube',
    'peacocktv.com': 'Peacock',
    'peacock.com': 'Peacock'
  };

  for (const [key, value] of Object.entries(nameMap)) {
    if (hostname.includes(key)) {
      return value;
    }
  }

  // Fallback: format the hostname nicely
  return hostname.split('.')[0].charAt(0).toUpperCase() + hostname.split('.')[0].slice(1);
};
